import React from 'react';
import Icon from '../../atoms/Icon/Icon';
import type { IconName } from '../../icons/types';

export type AuthProvider = 'google' | 'microsoft';

const ICON_BY_PROVIDER: Record<AuthProvider, IconName> = {
  google: 'google',
  microsoft: 'microsoft',
};

type AuthProviderButtonProps = {
  ariaLabel?: string;
  className?: string;
  isDisabled?: boolean;
  isFullWidth?: boolean;
  isLoading?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  provider: AuthProvider;
  testid?: string;
  text: string;
};

const AuthProviderButton = React.forwardRef<HTMLButtonElement, AuthProviderButtonProps>(
  ({ ariaLabel, className, isDisabled = false, isFullWidth = false, isLoading = false, onClick, provider, testid, text }, ref) => {
    const isInteractionBlocked = isDisabled || isLoading;
    const rootClassName = [
      'ui-auth-provider-button',
      `ui-auth-provider-button--${provider}`,
      isFullWidth ? 'ui-auth-provider-button--full-width' : null,
      isLoading ? 'ui-auth-provider-button--loading' : null,
      className,
    ]
      .filter(Boolean)
      .join(' ');
    return (
      <button
        ref={ref}
        aria-busy={isLoading || undefined}
        aria-disabled={isDisabled || undefined}
        aria-label={ariaLabel ?? text}
        className={rootClassName}
        data-testid={testid}
        disabled={isInteractionBlocked}
        onClick={onClick}
        type="button"
      >
        <span aria-hidden="true" className="ui-auth-provider-button__icon">
          <Icon name={ICON_BY_PROVIDER[provider]} />
        </span>
        <span className="ui-auth-provider-button__label">{text}</span>
      </button>
    );
  },
);

AuthProviderButton.displayName = 'AuthProviderButton';

export default AuthProviderButton;
